import { ErrorMessage, useField } from "formik"
import * as React from "react"
import { useCallback } from "react"

import Dropdown from "../../../design-system/dropdown"
import { ValueOption } from "../../../design-system/dropdown/selection-box/types"
import Field from "../../../design-system/field"
import InputError from "../../../design-system/input-error"
import Label from "../../../design-system/label"

interface Props {
  name: string
  errorMessage?: string
  className?: string
  label: string
  options: { label: string; value: string }[]
  placeholder?: string
  onOptionSelect?: (value: string) => void
  validate?: (value: string) => string | undefined
}
const DropdownField = ({
  name,
  placeholder = "Select one...",
  label,
  className,
  options,
  onOptionSelect,
  validate,
  ...rest
}: Props) => {
  const [field, meta, helpers] = useField<string>({ ...rest, name, validate })
  const handleOptionSelect = useCallback(
    (option: ValueOption) => {
      helpers.setValue(option.value)
      onOptionSelect?.(option.value)
    },
    [helpers, onOptionSelect],
  )
  return (
    <Field className={className}>
      <Label htmlFor={name}>{label}</Label>
      <Dropdown
        id={name}
        placeholder={placeholder}
        onOptionSelect={handleOptionSelect}
        value={field.value}
        options={options}
        onBlur={field.onBlur}
        invalid={meta.touched && !!meta.error}
      />
      <ErrorMessage name={name} component={InputError} />
    </Field>
  )
}

export default DropdownField
